// extracted by mini-css-extract-plugin
export default {"expirationOptions":"PricingExpiredButton_expirationOptions__RdeA5"};